import { useState, useEffect } from 'react';
import "./FormDeleteModal.css";
import Modal from "../shared/Modal";

type FormDeleteModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

export const FormDeleteModal = ({isOpen, onClose, onSubmit}: FormDeleteModalProps) => {

    // console.log("[FormDeleteModal] isOpen: ", isOpen);

    return (
        <Modal
            isOpen={isOpen}
            style={null}
            onClose={onClose}
            canClose={true}
            allowClickout={true}
        >
            <div className="form-delete-container">

                <div className="modal-title">
                    Delete Form
                </div>
                
                Are you sure you want to delete this form? Any responses will be deleted as well. This action is unrecoverable.

                <div className="modal-buttons">
                    <button 
                        className="button-cancel"
                        onClick={onClose}
                    > 
                        Cancel
                    </button>

                    <button 
                        className="button-save"
                        onClick={onSubmit}> 
                        Delete
                    </button>
                </div>
                
            </div>
      </Modal>
    )
}